module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.contextFilter || _vm.inContextNodeIds) ? _c('li', {
    class: ['tree-node', {
      transclusion: _vm.isTransclusion
    }],
    attrs: {
      "id": _vm.node.id
    }
  }, [_c('div', {
    class: ['content', {
      highlight: _vm.hasMatch
    }]
  }, [(_vm.childCount) ? _c('div', {
    class: _vm.arrowClass,
    on: {
      "click": _vm.toggleCollapsed
    }
  }) : _c('div', {
    directives: [{
      name: "dragula",
      rawName: "v-dragula",
      value: ([]),
      expression: "[]"
    }],
    staticClass: "drop-area",
    attrs: {
      "title": "Drop an infobit here to create a child",
      "bag": "infobits"
    }
  }), _vm._v(" "), _c('infobit', {
    ref: "infobit",
    attrs: {
      "infobit": _vm.node.infobit,
      "tabIndex": _vm.tabIndex
    }
  }, [_c('div', [_c('button', {
    staticClass: "fa fa-level-up",
    attrs: {
      "title": "View as tree root"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setSubtreeFilter($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "fa fa-exchange",
    attrs: {
      "title": "Retype",
      "disabled": !_vm.loggedInUser
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "fa fa-remove",
    attrs: {
      "title": "Remove from tree",
      "disabled": !_vm.loggedInUser
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.remove($event)
      }
    }
  })]), _vm._v(" "), _c('div', _vm._l((_vm.sortModes), function(sort, sortMode) {
    return _c('button', {
      class: ['fa', 'fa-' + sort.icon, {
        highlight: _vm.isSelectedSortMode(sortMode)
      }],
      attrs: {
        "title": sort.titleLabel,
        "disabled": !_vm.isSortable
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setSortMode(sortMode)
        }
      }
    })
  }), 0), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "fa fa-scissors",
    attrs: {
      "title": "Cut",
      "disabled": !_vm.loggedInUser
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cutToClipboard($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "fa fa-copy",
    attrs: {
      "title": "Copy"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.copyToClipboard($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "fa fa-share-alt",
    attrs: {
      "title": "Copy as transclusion"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.transcludeToClipboard($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "fa fa-paste",
    attrs: {
      "title": "Paste as child",
      "disabled": !_vm.clipboardContent || !_vm.loggedInUser || _vm.isChildNode
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.pasteSubtree($event)
      }
    }
  })])])], 1), _vm._v(" "), (_vm.showModal) ? _c('retype-dialog', {
    attrs: {
      "infobit": _vm.node.infobit
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.childCount && !_vm.isCollapsed) ? _c('ul', {
    directives: [{
      name: "dragula",
      rawName: "v-dragula",
      value: (_vm.sortedNodes),
      expression: "sortedNodes"
    }],
    staticClass: "child-nodes",
    attrs: {
      "bag": "infobits"
    }
  }, _vm._l((_vm.sortedNodes), function(childNode) {
    return _c('tree-node', {
      key: childNode.id,
      attrs: {
        "node": childNode
      }
    })
  }), 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36d7d44c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tree-node.vue
// module id = 140
// module chunks = 0